import sendReq from '@/utils/request'

export const getSignalReport = async ({ commit }, data) => {
    commit('reportLoading', true);
    let res;
    res = await sendReq("get","/reports/signals", data)
    commit('signalReports', res);
    commit('reportLoading', false);
}

export const getFlexReport = async ({ commit }, data) => {
    commit('reportLoading', true);
    let res;
    res = await sendReq("get","/reports/flexible-columns/"+data)
    commit('setColumns', res);
    commit('reportLoading', false);
}

export const downloadFlexReport = async ({ commit }, data) => {
    commit('reportLoading', true);
    let res;
    res = await sendReq("get","/reports/flex/"+data.code, data.data)
    commit('flexReport', res);
    commit('reportLoading', false);
}



// WEBPACK FOOTER //
// ./src/store/modules/Reports/Actions.js